import React from "react";
import { CheckCircle2, LockKeyhole, ShieldCheck } from "lucide-react";
import BuyButton from "@/components/BuyButton";
import { useStudyAuth } from "@/context/StudyAuth";

const INCLUDED = [
  "Complete Illinois, national, and math question library",
  "Full learning path and Word Bank",
  "National and Illinois exam simulations",
  "Readiness, weak-area, and missed-question tools",
  "Question Coach help across the full library",
];

export default function UpgradeGate({
  eyebrow = "Full access",
  title = "Unlock the complete study platform.",
  description = "Your free progress is already saved. Upgrade once and continue from exactly where you left off.",
}) {
  const { email } = useStudyAuth();

  return (
    <section className="overflow-hidden border border-[color:rgba(10,27,51,0.13)] bg-white shadow-[0_14px_36px_rgba(7,20,39,0.07)]">
      <div className="bg-[var(--ibp-navy-950)] px-6 py-7 text-white sm:px-8">
        <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-[var(--ibp-gold-500)]">
          <LockKeyhole className="h-4 w-4" /> {eyebrow}
        </p>
        <h1 className="mt-2 max-w-2xl text-2xl font-bold sm:text-3xl">{title}</h1>
        <p className="mt-3 max-w-2xl text-sm leading-6 text-white/72 sm:text-base">{description}</p>
      </div>

      <div className="grid gap-8 px-6 py-7 sm:px-8 lg:grid-cols-[minmax(0,1fr)_17rem] lg:items-center">
        <div>
          <h2 className="text-sm font-semibold text-[var(--ibp-ink)]">Everything included for $79</h2>
          <ul className="mt-4 space-y-3">
            {INCLUDED.map((item) => (
              <li key={item} className="flex items-start gap-2 text-sm leading-6 text-[color:rgba(11,18,32,0.72)]">
                <CheckCircle2 className="mt-1 h-4 w-4 shrink-0 text-[#15803d]" /> {item}
              </li>
            ))}
          </ul>
        </div>

        <div className="border-l-4 border-l-[var(--ibp-gold-500)] bg-[var(--ibp-offwhite)] px-5 py-5">
          <p className="text-3xl font-bold text-[var(--ibp-ink)]">$79</p>
          <p className="mt-1 text-sm text-[color:rgba(11,18,32,0.62)]">One payment. Lifetime access.</p>
          <BuyButton label="Unlock full access — $79" fullWidth className="mt-5" />
          <p className="mt-3 text-xs leading-5 text-[color:rgba(11,18,32,0.55)]">
            At checkout, use <strong className="break-all text-[var(--ibp-ink)]">{email}</strong> so access connects to this account automatically.
          </p>
          <p className="mt-3 flex items-start gap-1.5 text-xs leading-5 text-[color:rgba(11,18,32,0.55)]">
            <ShieldCheck className="mt-0.5 h-3.5 w-3.5 shrink-0" /> Secure Shopify checkout · 7-day satisfaction refund
          </p>
        </div>
      </div>
    </section>
  );
}

